var Header = (function () {
    function Header() {
        this.progid = 0;
        this.version = 0;
        this.type = "";
    }
    return Header;
}());
export { Header };



// WEBPACK FOOTER //
// ../dist/lib/aglsl/Header.js